import React, { ReactNode } from 'react';

import { getRandomString } from '../../../utils';
import { CrumbItem, CrumbItemWrapper, CrumbsWrapper, LastCrumbItem, NextCrumbIcon } from './style';

export type Crumb = {
  label: ReactNode;
  to: string;
  dataTestId?: string;
};

export interface Props {
  items: Crumb[];
  dataTestId?: string;
}

const Breadcrumbs = ({ items, dataTestId }: Props): JSX.Element => {
  return (
    <CrumbsWrapper data-test-id={dataTestId}>
      {items.map((crumb, index) => {
        if (typeof crumb.label !== 'string') {
          return <CrumbItemWrapper key={getRandomString()}>{crumb.label}</CrumbItemWrapper>;
        }
        if (index === items.length - 1) {
          return (
            <CrumbItemWrapper key={getRandomString()}>
              <LastCrumbItem>{crumb.label}</LastCrumbItem>
            </CrumbItemWrapper>
          );
        }
        return (
          <CrumbItemWrapper data-test-id={crumb.dataTestId} key={getRandomString()}>
            <CrumbItem to={crumb.to}>{crumb.label}</CrumbItem>
            <NextCrumbIcon />
          </CrumbItemWrapper>
        );
      })}
    </CrumbsWrapper>
  );
};

export default Breadcrumbs;
